import React from 'react';
import { Hero } from './Hero';
import { ProblemAgitation } from './ProblemAgitation';
import { Mechanism } from './Mechanism';
import { ProductIncludes } from './ProductIncludes';
import { RealExamples } from './RealExamples';
import { OfferCTA } from './OfferCTA';
import { Footer } from './Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-cream text-brown overflow-x-hidden" data-id="element-200">
      {/* Simple Header */}
      <header className="py-6 px-6 border-b border-brown/5 bg-cream/80 backdrop-blur-sm sticky top-0 z-50" data-id="element-201">
        <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-202">
          <span className="font-serif font-bold text-xl tracking-tight" data-id="element-203">
            Reset 4 Pilares
          </span>
          <span className="text-sm font-medium text-terracotta bg-terracotta/10 px-3 py-1 rounded-full" data-id="element-204">
            Versión 0.1
          </span>
        </div>
      </header>

      <main data-id="element-205">
        <Hero data-id="element-206" />
        <ProblemAgitation data-id="element-207" />
        <Mechanism data-id="element-208" />
        <ProductIncludes data-id="element-209" />
        <RealExamples data-id="element-210" />
        <OfferCTA data-id="element-211" />
      </main>

      <Footer data-id="element-212" />
    </div>;
}